/* eslint-disable */
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import { useEffect, useState } from "react";
function chat() {
  // const Store = useSelector((state) => state.StoreReducer);

  //  const token = Store.foorchat.page.find(p => p.pageId === pageId)?.tokenFbChatbot;
  const pageId = "376257815565255";
  const token =
    "EAANt6mxZAdecBPAlYaK8GrSQOZBnkkbVCRaMaat2MBf6gZCIogZBOpLEfhBSYmJOm4OIam2n5jtHrOZBYJrHvA0xEN1ZBbjSUoE9ZChpsJQCxDq6hmkUtqDtVtULHCUTWRs0DxejtB0uq9lClUDQq5isDk6TnpEyQXxJv5DHSCqBXWHWnZBD3NMTuxOn0Ny4Q9S3YdVRD6Q9mDfCzAAdtWAZBoeZAAaQmsHlb7avyZAg4NZAwNmbh0uUyMiLHdEZD";
  const [showSideBar, setShowSideBar] = useState(false);
  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  return (
    <>
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
      </div>
      <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
      <iframe
        src={`http://localhost:5173/apps/chat?pageid=122100141146016044&token=${token}`}
        width="100%"
        height="100%"
      ></iframe>
    </>
  );
}
export default chat;
